import { render, staticRenderFns } from "./CardItemNew.vue?vue&type=template&id=8b796f00&scoped=true&"
import script from "./CardItemNew.vue?vue&type=script&lang=js&"
export * from "./CardItemNew.vue?vue&type=script&lang=js&"
import style0 from "./CardItemNew.vue?vue&type=style&index=0&id=8b796f00&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b796f00",
  null
  
)

export default component.exports